import React, { useState, useEffect } from 'react';
import { IdResult, IdInfo, BtnDownload, BtnCreate, BtnReset, CatHeadline, ColLow, GroupBox, ColContainer, SingleRow, Cols } from '../components/component.js';
import { Railway } from '../components/jptr-redirect';
import { CloudStrike } from '../base/clrsplt-CloudConnect';
import { DefaultLink, DefaultMessage } from '../components/jptr-default.js';
import '../components/jptr-redirect.css';


export default function Cntntswp() {

    const [order, setOrder] = useState([0, 1, 2, 3]);
    const [reset, setReset] = useState(false);

    const [linkId, setLinkId] = useState(DefaultLink.ID);
    const [linkInfo, setLinkInfo] = useState(DefaultLink.INFO);

    const [downloadable, setDownloadable] = useState(false);
    useEffect(() => {

        if (linkId === DefaultLink.ID || linkId === DefaultMessage.MESSAGE.calculating) {
            setDownloadable(false);
            setLinkInfo(DefaultLink.INFO);
            return;
        }
        setDownloadable(true);
    }, [linkId, setDownloadable, setLinkInfo]);

    useEffect(() => {
        if (reset || order) {
            setLinkId(DefaultLink.ID);
        }
    }, [reset, order]);

    const handleOrderChange = (newOrder) => {
        setOrder(newOrder);
    };

    const handlerResetRailway = () => {
        setReset(true);
        setTimeout(() => setReset(false), 0);
        setLinkId(DefaultLink.ID);
    };

    const handlerCreateSwap = () => {

        setLinkId(DefaultMessage.MESSAGE.calculating);

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "orderOld": Array.from({ length: order.length }, (_, i) => i),
                "orderNew": order.map(waggon => waggon.originalIndex),
            }),
            redirect: "follow"
        };

        const strike = new CloudStrike();
        strike.sendRequest('/link/swaplink', requestOptions)
            .then((data) => {
                setLinkId(data.body.fileID);
                setLinkInfo({
                    bytes: data.body.filesize,
                    channels: data.body.colormode,
                    duration: data.body.elapsed
                });

                localStorage.setItem('jptr-id-link', data.body.fileID);
            })
            .catch((error) => console.error(error))
    }

    const handleDownload = async () => {
        const strike = new CloudStrike();
        await strike.downloadLink(linkId, CloudStrike.LINK_TYPE.swapLink)
            .catch(error => { throw error; });
    };

    return (
        <ColContainer>
            <ColLow>
                <CatHeadline name="Swaplink" />
                <p style={{ maxWidth: "700px", width: "100%" }}>
                    A swap link redirects a channel of a colorset or profile order. It maps an incoming
                    position to a new position of the output, streamlining your workflow. You can save
                    and share it with others. The order is left to right. Drag and drop the elements to
                    change the sequence.
                </p>
            </ColLow>

            <GroupBox>
                <Railway onOrderChange={handleOrderChange} reset={reset} />
                <SingleRow>
                    <BtnCreate onClick={handlerCreateSwap} />
                    <BtnReset onClick={handlerResetRailway} />
                </SingleRow>
            </GroupBox>

            <Cols>
                <IdResult linkId={linkId} />
                <IdInfo {...linkInfo} />
                <BtnDownload isDisabled={downloadable} onDownload={handleDownload} />
            </Cols>
        </ColContainer>
    );
}
